import React from 'react';
import Icon, { NAMES } from '../Icon';
import PropTypes from "prop-types";
import PillButton, { VARIANTS } from '../PillButton';

const ShareButton = ({ sharePage, size = "s", iconOnly }) => {
    const iconSize = size === "m" ? "s" : size;
    return (
        <PillButton
            variant={VARIANTS.PINK}
            onClick={sharePage}
            icon={<Icon size={iconSize} name={NAMES.ShareArrow} color="white" />}
            style={{ minWidth: "auto", fontSize: "15px", fontWeight: 500, padding: "6px 14px", backgroundColor: "#ff4f88", color: "#fff" }}
        >
            {!iconOnly && "Share"}
        </PillButton>
    );
};

ShareButton.propTypes = {
    sharePage: PropTypes.func.isRequired,
    size: PropTypes.string.isRequired,
    iconOnly:  PropTypes.bool,
};

export default ShareButton;
